// "fewer than three in four of the cast" — where a measured value sits against the
// writers' own cast, given that field's quartiles [p25, p50, p75]. The builds store
// the quartiles beside each character's numbers; both writers' characters sit in
// narrow bands, so a number means something only against the others (2026-10-12).
export function castPhrase(value, q, more = 'more', fewer = 'fewer') {
  const v = Number(value);
  if (!Number.isFinite(v) || !Array.isArray(q) || q.length !== 3) return '';
  const [p25, p50, p75] = q.map(Number);
  if (v <= p25) return `${fewer} than three in four of the cast`;
  if (v >= p75) return `${more} than three in four of the cast`;
  if (v < p50) return `${fewer} than most of the cast`;
  if (v > p50) return `${more} than most of the cast`;
  return "the cast's middle";
}
